import React, { useEffect, useState, useContext } from 'react'
import MyContext from '../../../context/MyContext'

export const BackShades = (props) => {
    const { setBackgrounds } = useContext(MyContext)

    const setBackColor = (obj) => {
        
        setBackgrounds({type:'color', color: obj, Path: null, gradient: { Gcolor: null, FirstColor: null, SecondColor: null } })
    }

    const [Furthershades, setFurthershades] = useState([{

        type: "shades",
        color: 'rgb(231,158,113)',
    }, {

        type: "shades",
        color: 'rgb(236,178,142)',
    }, {

        type: "shades",
        color: 'rgb(240,197,170)',
    },
    {

        type: "shades",
        color: 'rgb(245,216,198)',
    },
    {

        type: "shades",
        color: 'rgb(250,236,227)',
    },
    ]);

    useEffect(() => {

        if (props.RgbSet.length != 0) {

            // Five lighter tints of the picked colour. (Before, 33 was added to each channel five
            // times, so values went above 255: the last swatches all came out the same near-white
            // and out-of-range values such as "rgb(292,205,151)" were saved with the project.)
            const base = [props.RgbSet.r, props.RgbSet.g, props.RgbSet.b].map((v) => Math.min(255, Math.max(0, Math.round(Number(v) || 0))));

            for (var i = 0; i < 5; i++) {
                const k = (i + 1) / 6;
                const [r, g, b] = base.map((v) => Math.round(v + (255 - v) * k));

                let CreatedShades = {
                    type: "shades",
                    color: 'rgb(' + r + "," + g + "," + b + ')',
                };
                if (i === 0) {
                    setFurthershades([])
                }

                setFurthershades(Furthershades => ([...Furthershades, CreatedShades]));
            }
        }

    }, [props.RgbSet]);

    return (<>

        {Furthershades.map((value, index) => {
            return (<div key={index} onClick={() => setBackColor(value.color)}
                className="color-box2"
                style={{ background: value.color }}
            ></div>
            )
        })}

    </>)

}
export default BackShades;